import React, { useContext, useState } from 'react';
import { Auth } from 'aws-amplify';

import { AuthenticatorContext } from './AuthenticatorContext';
import {
   AuthenticatorButton,
   AuthenticatorForm,
   AuthenticatorInput,
   AuthenticatorSubmitButton,
} from './AuthenticatorForm';

const ForgotPassword = () => {
   const { dispatch } = useContext(AuthenticatorContext);
   const [codeSent, setCodeSent] = useState(false);
   return (
      <AuthenticatorForm
         heading="Reset Password"
         onSubmit={(formData) => {
            if (codeSent) {
               return Auth.forgotPasswordSubmit(
                  formData.get('email'),
                  formData.get('code'),
                  formData.get('password')
               ).then(() => {
                  dispatch({
                     type: 'changeView',
                     view: 'logIn',
                     successMessage:
                        'Password reset successful. You can now log in using your new password.',
                  });
               });
            }

            return Auth.forgotPassword(formData.get('email')).then(() => {
               dispatch({
                  type: 'submitComplete',
               });
               setCodeSent(true);
            });
         }}
      >
         <AuthenticatorInput
            name="email"
            type="email"
            autoComplete="email"
            placeholder="Email"
            readOnly={codeSent}
            required
            autoFocus
         />
         {codeSent && <p>A confirmation code has been sent to your email.</p>}
         {codeSent && (
            <AuthenticatorInput
               name="code"
               autoComplete="one-time-code"
               placeholder="Confirmation Code"
               required
               autoFocus
            />
         )}
         {codeSent && (
            <AuthenticatorInput
               name="password"
               type="password"
               autoComplete="new-password"
               placeholder="New Password"
               required
               minLength="8"
            />
         )}
         <AuthenticatorSubmitButton>
            {codeSent ? 'Reset Password' : 'Request Password Reset'}
         </AuthenticatorSubmitButton>
         <p>
            <AuthenticatorButton
               className="button-link"
               onClick={() => dispatch({ type: 'changeView', view: 'logIn' })}
            >
               Back to Log In
            </AuthenticatorButton>
         </p>
      </AuthenticatorForm>
   );
};

export { ForgotPassword };
